<template>
  <div class="content" id="methodology">
    <section class="section features" id="features">
      <h2 class="h2 section-title underline">WORK METHODOLOGY</h2>
      <img :src="currentImage" alt="Gráfico" >
    </section>
  </div>
</template>

<script>
import imagemPeopleDesktop from '@/assets/img/grafico.png';
import imagemPeopleMobile from '@/assets/img/graficomobile.png';

export default {
  data() {
    return {
      isMobile: window.innerWidth <= 768

      
    }
  },
  computed: {
    currentImage() {
      return this.isMobile ? imagemPeopleMobile : imagemPeopleDesktop;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    }
  }
}
</script>

<style scoped>

.section img{
  width: 100%;
}
.section-title{
  margin-top: 3%;
}
.content{
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
/*-----------------------------------*\
  #FEATURE
\*-----------------------------------*/

.features-list > li:first-child {
  margin-block-end: 30px;
}

.features-card {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.features-card .icon {
  background-image: var(--gradient-1);
  background-size: 200%;
  color: var(--white);
  min-width: max-content;
  max-width: max-content;
  font-size: 36px;
  padding: 22px;
  border-radius: 50%;
}

.features-card .icon ion-icon {
  --ionicon-stroke-width: 20px;
}

.features-card .title {
  margin-block-end: 10px;
}

.features-banner {
  margin-block: 40px;
}

.features-banner > img {
  max-width: max-content;
  margin-inline: auto;

}

@media (max-width: 768px) {
  
  .section img{
    width: 300px; 
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5%;
  }

}

</style>